import RouteTemplate from 'ember-route-template';

export default RouteTemplate<{ Args: { model: unknown; controller: unknown } }>(
  <template>
    <div class='onboarding onboarding--loading u-cover'>
      <div class='logo-animation'></div>
    </div>
  </template>
);
